import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Routers from "../../routers/Routers";
import useUserSync from "../../custom-hooks/useUserSync";

const Layout = () => {
  // Syncs user's cart and wishlist with Firestore and handles logout purge
  useUserSync();

  return (
    <>
      <Header />
      <div className="main">
        <Routers />
      </div>
      <Footer />
    </>
  );
};

export default Layout;
